import vue from "vue";

export default {
    SET_CITIES: (state, payload) => {
        state.cities = payload;
    },
    SET_COUNTRIES: (state, payload) => {
        // payload.forEach((element,index) => {
        //     vue.set(state.countries, index, element)
        // });
        state.countries = [...payload];
    },
    SET_PROVINCES: (state, payload) => {
        state.provinces = payload;
    },
    SET_ISSUED_COUNTRIES: (state, payload) => {
        state.issuedCountries = payload;
    },
    SET_ISSUED_PROVINCES: (state, payload) => {
        state.issuedProvinces = payload;
    },
    SET_ISSUED_CITIES: (state, payload) => {
        state.issuedCities = payload;
    },
    SET_BIRTH_CITIES: (state, payload) => {
        state.birthCities = payload;
    },
}